var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('revenue-chart',{attrs:{"height":200}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }